'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.PreisbezeichnungSchema = {
  title: 'Preisbezeichnung',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/preisBezeichnung.js
// module id = /VmO
// module chunks = 0